import { render, staticRenderFns } from "./ZhuHuiDangJian.vue?vue&type=template&id=741935b8&scoped=true&"
import script from "./ZhuHuiDangJian.vue?vue&type=script&lang=js&"
export * from "./ZhuHuiDangJian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741935b8",
  null
  
)

export default component.exports